import React from "react";
import { FaDollarSign } from "react-icons/fa";
import Popup from "../../../../../components/Popup";



export function CostCenterInfoPopUp(props) {
    return(
        <Popup
            visibility={props.visibility}
            setVisibility={props.setVisibility}
            tittle={"Centro de Custo"}
            icon={<FaDollarSign/>}
        >
            <div className="records-element-info">
                <p><b>Nome: </b>{props.costCenter && props.costCenter.nome ? props.costCenter.nome : ""}</p>
            </div>
        </Popup>
)
}